import { AncillaryChargeType } from '../graphql/generated/graphql';

/**
 * Human labels for the ancillary catalogue. Typed as a total `Record` on purpose: adding a member
 * to the enum is then a compile error until it is labelled here, so the dialog, the transactions
 * strip and the tax invoice can never drift apart or render a raw camelCase code.
 */
export const ANCILLARY_LABELS: Record<AncillaryChargeType, string> = {
  [AncillaryChargeType.SeatSelection]: 'Seat selection',
  [AncillaryChargeType.CheckedBaggage]: 'Checked baggage',
  [AncillaryChargeType.ExcessBaggage]: 'Excess baggage',
  [AncillaryChargeType.Meals]: 'Meal / catering',
  [AncillaryChargeType.LoungeAccess]: 'Lounge access',
  [AncillaryChargeType.Wifi]: 'In-flight Wi-Fi',
  [AncillaryChargeType.ChangeFee]: 'Change fee',
  [AncillaryChargeType.CancellationFee]: 'Cancellation fee',
  [AncillaryChargeType.Other]: 'Other',
};

/** Dropdown options for the charge dialog, in catalogue order. */
export const ANCILLARY_OPTIONS: { value: AncillaryChargeType; label: string }[] = Object.values(
  AncillaryChargeType,
).map((value) => ({ value, label: ANCILLARY_LABELS[value] }));

/**
 * Label a persisted breakdown line. The description is what the charge was written as, so it stands on its own
 * rather than trailing the catalogue name: "Airline change fee" reads as the line it is, where the name and the
 * note side by side only said the same thing twice. Tolerates an unknown code so a record written by a newer
 * backend than this bundle still renders something readable rather than blank.
 */
export function ancillaryLineLabel(
  ancillaryType: AncillaryChargeType | null | undefined,
  description?: string | null,
): string {
  if (description) {
    return description;
  }

  return ancillaryType ? (ANCILLARY_LABELS[ancillaryType] ?? 'Ancillary') : 'Ancillary';
}
